import { RouterProvider } from "react-router-dom";
import AppRouter from "./AppRouter/AppRouter";
import { Provider } from "react-redux";
import { configureStore } from "./AppStore/store";
import { AuthContextProvider } from "./AppContext/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";
import { ProjectContextProvider } from "./AppContext/ProjectContext";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { InviteContextProvider } from "./AppContext/InviteContext";
import { PayContextProvider } from "./AppContext/PayContext";
import { AccountContextProvider } from "./AppContext/AccountContext";
import { CommitteeContextProvider } from "./AppContext/CommitteeContext";
import PermissionMode from "./Shared/PermissionMode";
import InstallPrompt from "./Shared/InstallPrompt";

const queryClient = new QueryClient();

function App() {
  return (
    <Provider store={configureStore()}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <CommitteeContextProvider>
          <InviteContextProvider>
            <AccountContextProvider>
              <PayContextProvider>
                <ProjectContextProvider>
                  <PermissionMode>
                    <RouterProvider router={AppRouter} />
                    <InstallPrompt />
                  </PermissionMode>
                </ProjectContextProvider>
              </PayContextProvider>
            </AccountContextProvider>
          </InviteContextProvider>
          </CommitteeContextProvider>
        </AuthContextProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
